import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { notify } from "../utils/methods/notification";
import api from "../services/api/axios.config";

const initialState = {
  inboundListing: [],
  selectOutboundList: {},
  approvedLSMList: [],
  vienToVienLoading: false,
  recievedLSMList: [],
  isLoading: false,
};

// For fetch Logistic details
export const fetchLogisticDetails = createAsyncThunk(
  "bmr/fetchInboundListingDetails",
  async (id, { rejectWithValue }) => {
    try {
      const response = await api.get(`/logistics/details/${id}`);
      return response.data;
    } catch (error) {
      notify.error(error || error.message || error.response || error.response.data)
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

// For Fetching Inbound Listing
export const getInboundListing = createAsyncThunk(
  "bmr/fetchInboundListing",
  async (filters, { rejectWithValue }) => {
    try {
      const response = await api.post(`/logistics/list`, filters);
      return response.data;
    } catch (error) {
       notify.error(error || error.message || error.response || error.response.data)
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);
// For Fetching Outbound Listing
export const fetchOutboundListing = createAsyncThunk(
  "bmr/fetchOutboundListing",
  async (filters, { rejectWithValue }) => {
    try {
      const response = await api.post(`/product-manufacturing/outbound/patient/list`, filters);
      return response.data;
    } catch (error) {
       notify.error(error || error.message || error.response || error.response.data)
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

// For Fetching Approved LSM Listing
export const getApprovedLSMListing = createAsyncThunk(
  "bmr/fetchApprovedLSMListing",
  async (filters, { rejectWithValue }) => {
    try {
      const response = await api.post(`/logistics/lsm/approved-list`, filters);
      return response.data;
    } catch (error) {
       notify.error(error || error.message || error.response || error.response.data)
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

// For Fetching Recieved LSM Listing
export const getRecievedLSMListing = createAsyncThunk(
  "bmr/fetchRecievedLSMListing",
  async (filters, { rejectWithValue }) => {
    try {
      const response = await api.post(`/logistics/lsm/received-list`, filters);
      return response.data;
    } catch (error) {
       notify.error(error || error.message || error.response || error.response.data)
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);





// Api for Mark the Shipment done
export const createShipement = createAsyncThunk(
  "bmr/markAsShipped",
  async (data, { rejectWithValue }) => {
    try {
      const response = await api.post(`/logistics/create`, data);
      notify.success(response.data.message);
      return response.data;
    } catch (error) {
       notify.error(error || error.message || error.response || error.response.data)
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

// Api for Mark the Shipment done
export const createOutbondShipement = createAsyncThunk(
  "bmr/createOutbondShipement",
  async (data, { rejectWithValue }) => {
    try {
      const response = await api.post(`/outbound-form/create/shipment`, data);
      notify.success(response.data.message);
      return response.data;
    } catch (error) {
       notify.error( error || error.message || error.response || error.response.data )
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

// Api for Mark LSM Recieved
export const recieveLSM = createAsyncThunk(
  "bmr/markAsRecieved",
  async ({ id, feasibility_assessments_id='' },
 { rejectWithValue }) => {
    try {
        let url = `/logistics/set-received/${id}`;
        if(feasibility_assessments_id)
        url += `?feasibility_assessments_id=${feasibility_assessments_id}`
      const response = await api.patch(url, {});
      notify.success(response.data.message);
      return response.data;
    } catch (error) {
      notify.error(
          error || error.message || error.response || error.response.data
      )
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

// Api for Mark LSM Recieved
export const recieveProductLSM = createAsyncThunk(
  "bmr/recieveProductLSM",
  async (id, { rejectWithValue }) => {
    try {
      const response = await api.patch(`/outbound-form/set-received/${id}`, {});
      notify.success(response.data.message);
      return response.data;
    } catch (error) {
      notify.error(
          error || error.message || error.response || error.response.data
      )
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

// Api for Mark LSM Recieved
export const startInfusion = createAsyncThunk(
  "bmr/startInfusion",
  async (id, { rejectWithValue }) => {
    try {
      const response = await api.patch(`/outbound-form/start-infusion/${id}`, {});
      notify.success(response.data.message);
      return response.data;
    } catch (error) {
       notify.error(
          error || error.message || error.response || error.response.data
        )
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

// Api for Mark LSM Recieved
export const completeInfusion = createAsyncThunk(
  "bmr/completeInfusion",
  async (id, { rejectWithValue }) => {
    try {
      const response = await api.patch(`/outbound-form/complete-infusion/${id}`, {});
      notify.success(response.data.message);
      return response.data;
    } catch (error) {
       notify.error(
          error || error.message || error.response || error.response.data
        )
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);




//Reject LSM ket
export const rejectedLSM = createAsyncThunk(
  "bmr/rejectedLSM",
  async (args, { rejectWithValue }) => {
    try {
      const { id, data } = args
      const response = await api.post(`/logistics/reject-lsm/${id}`, data);
      notify.success(response.data.message);
      return response.data;
    } catch (error) {
       notify.error(
          error || error.message || error.response || error.response.data
        )
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

//Reject LSM ket
export const modeOfRejectionLSM = createAsyncThunk(
  "bmr/modeOfRejectionLSM",
  async (args, { rejectWithValue }) => {
    try {
      const { id, data } = args
      const response = await api.post(`/logistics/mode-of-lsm-rejection/${id}`, data);
      notify.success(response.data.message || response.message);
      return response.data;
    } catch (error) {
      notify.error(error || error.message || error.response || error.response.data);
   
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

//Reject LSM ket
export const manufactureRequestApproved = createAsyncThunk(
  "bmr/manufactureRequestApproved",
  async (args, { rejectWithValue }) => {
    try {
      const { id, data } = args
      const response = await api.patch(`/product-manufacturing/re-manufacture-request/approved/${id}`, data);
      notify.success(response.data.message || response.message);
      return response.data;
    } catch (error) {
      notify.error(error || error.message || error.response || error.response.data);
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

const logisticSlice = createSlice({
  name: "bmrLogistic",
  initialState,
  reducers: {},
  extraReducers: (builder) =>
    builder
      .addCase(getInboundListing.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getInboundListing.fulfilled, (state, action) => {
        state.inboundListing = action.payload.data ?? [];
        state.isLoading = false;
      })
      .addCase(getInboundListing.rejected, (state) => {
        state.isLoading = false;
      })

      // Handling the state case for the LSM Approved listing
      .addCase(getApprovedLSMListing.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getApprovedLSMListing.fulfilled, (state, action) => {
        state.approvedLSMList = action.payload?.data ?? [];
        state.isLoading = false;
      })
      .addCase(getApprovedLSMListing.rejected, (state) => {
        state.isLoading = false;
      })

      // Handling the state case for the LSM Recieved listing
      .addCase(getRecievedLSMListing.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getRecievedLSMListing.fulfilled, (state, action) => {
        state.recievedLSMList = action.payload?.data ?? [];
        state.isLoading = false;
      })
      .addCase(getRecievedLSMListing.rejected, (state) => {
        state.isLoading = false;
      })

      // Handling the state case for the LSM fetchOutboundListing listing
      .addCase(fetchOutboundListing.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchOutboundListing.fulfilled, (state, action) => {
        state.outboundList = action.payload.data ?? {}
        state.isLoading = false;
      })
      .addCase(fetchOutboundListing.rejected, (state) => {
        state.isLoading = false;
      })

      // Handling the state case for the LSM createOutbondShipement listing
      .addCase(createOutbondShipement.pending, (state) => {
        state.vienToVienLoading = true;
      })
      .addCase(createOutbondShipement.fulfilled, (state) => {
        state.vienToVienLoading = false;
      })
      .addCase(createOutbondShipement.rejected, (state) => {
        state.vienToVienLoading = false;
      })

      // Handling the state case for the LSM Recieved listing
      .addCase(recieveProductLSM.pending, (state) => {
        state.vienToVienLoading = true;
      })
      .addCase(recieveProductLSM.fulfilled, (state) => {
        state.vienToVienLoading = false;
      })
      .addCase(recieveProductLSM.rejected, (state) => {
        state.vienToVienLoading = false;
      })

      // Handling the state case for the LSM startInfusion listing
      .addCase(startInfusion.pending, (state) => {
        state.vienToVienLoading = true;
      })
      .addCase(startInfusion.fulfilled, (state) => {
        state.vienToVienLoading = false;
      })
      .addCase(startInfusion.rejected, (state) => {
        state.vienToVienLoading = false;
      })

      // Handling the state case for the LSM startInfusion listing
      .addCase(manufactureRequestApproved.pending, (state) => {
        state.vienToVienLoading = true;
      })
      .addCase(manufactureRequestApproved.fulfilled, (state) => {
        state.vienToVienLoading = false;
      })
      .addCase(manufactureRequestApproved.rejected, (state) => {
        state.vienToVienLoading = false;
      })


      // Handling the state case for the reject LSM listing
      .addCase(rejectedLSM.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(rejectedLSM.fulfilled, (state) => {
        state.isLoading = false;
      })
      .addCase(rejectedLSM.rejected, (state) => {
        state.isLoading = false;
      })
      // Handling the state case for the mode of rejection LSM listing
      .addCase(modeOfRejectionLSM.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(modeOfRejectionLSM.fulfilled, (state) => {
        state.isLoading = false;
      })
      .addCase(modeOfRejectionLSM.rejected, (state) => {
        state.isLoading = false;
      })
      // Handling the state case for the mode of rejection LSM listing
      .addCase(completeInfusion.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(completeInfusion.fulfilled, (state) => {
        state.isLoading = false;
      })
      .addCase(completeInfusion.rejected, (state) => {
        state.isLoading = false;
      }),
});


export const selectRejectedLSMLoading = (state) => state.bmrLogistic.isLoading
export const selectVienToVienLoading = (state) => state.bmrLogistic.vienToVienLoading

export const selectOutboundList = (state) => state.bmrLogistic.outboundList





export default logisticSlice.reducer;
